import * as React from 'react';
import { Droppable } from 'react-beautiful-dnd';

// restrict sortable by using custom type
const DND_TYPE = 'SORTABLE_ROW';

type Props = {
  id: number,
  children: React.ReactNode
};

const SortableAnalyticsContainer = ({
  id,
  children
}: Props) => (
  <Droppable
    type={DND_TYPE}
    droppableId={`metrics-sortable-table-row-${id}`}
  >
    {(provided) => (
      <div
        {...provided.droppableProps}
        ref={provided.innerRef}
      >
        {children}
        {provided.placeholder}
      </div>
    )}
  </Droppable>
);


export default SortableAnalyticsContainer;
